import { Identifier, DocumentRecord, DocumentRecordData } from '../../offline-first';
import { Measure } from './exercise-program-document';

export interface Observation {
  id: Identifier;
  timestamp: string;
  measure: Measure;
  result: Result;
}

export interface Result {
  type: string;
}

export interface RMResult extends Result {
  exercise_id: string;
  value: number;
  reps: number;
}

export interface MaxSetResult extends Result {
  exercise_id: string;
  value: number;
  time_limit: number;
}

export interface SurveyResult extends Result {
  response: string | number;
  workout_session: string;
}

export class ObservationDocument extends DocumentRecord<Observation> {
  static recordName = 'ObservationDocument';
  static objectStoreName = 'observationDocuments';

  constructor(data?: DocumentRecordData<Observation>) {
    super(data);
  }
}
